module.exports = __webpack_public_path__ + "static/media/Branding.6ca22aa2.png";